import React from "react";
import "./InfoBar.css";
import online from "../../icons/online.png";
import close from "../../icons/close.png";

const InfoBar = ({ chatRoom }) => {
  return (
    <div className="info-bar">
      <div className="left-inner-container">
        <img src={online} alt="online icon" className="online-icon" />
        <h3>{chatRoom}</h3>
      </div>
      <div className="right-inner-container">
        <a href="/">
          <img src={close} alt="close icon" />
        </a>
      </div>
    </div>
  );
};

export default InfoBar;
